import script from "./goodsInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./goodsInfo.vue?vue&type=script&setup=true&lang=js"

import "./goodsInfo.vue?vue&type=style&index=0&id=4af187d0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4af187d0"]])

export default __exports__